import _classCallCheck from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import React from "react";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { DecoratorNode } from "lexical";

/** Serialized form of an image node. */

/** Renders the embedded image inside the editor. */
function ImageComponent(_ref) {
  var src = _ref.src,
    altText = _ref.altText;
  return /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: altText,
    className: "max-w-full rounded-sds-200"
  });
}

/** Converts an `<img>` element into an image node during HTML import. */
function convertImageElement(element) {
  var _image$getAttribute, _image$getAttribute2;
  var image = element;
  return {
    node: $createImageNode((_image$getAttribute = image.getAttribute("src")) !== null && _image$getAttribute !== void 0 ? _image$getAttribute : "", (_image$getAttribute2 = image.getAttribute("alt")) !== null && _image$getAttribute2 !== void 0 ? _image$getAttribute2 : "")
  };
}

/** Lexical decorator node for an embedded image. */
export var ImageNode = /*#__PURE__*/function (_DecoratorNode) {
  function ImageNode(src, altText, key) {
    var _this;
    _classCallCheck(this, ImageNode);
    _this = _callSuper(this, ImageNode, [key]);
    _this.__src = src;
    _this.__altText = altText;
    return _this;
  }
  _inherits(ImageNode, _DecoratorNode);
  return _createClass(ImageNode, [{
    key: "exportJSON",
    value: function exportJSON() {
      return {
        type: "image",
        version: 1,
        src: this.__src,
        altText: this.__altText
      };
    }
  }, {
    key: "exportDOM",
    value: function exportDOM() {
      var element = document.createElement("img");
      element.setAttribute("src", this.__src);
      element.setAttribute("alt", this.__altText);
      return {
        element: element
      };
    }
  }, {
    key: "createDOM",
    value: function createDOM() {
      return document.createElement("span");
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return false;
    }
  }, {
    key: "decorate",
    value: function decorate() {
      return /*#__PURE__*/React.createElement(ImageComponent, {
        src: this.__src,
        altText: this.__altText
      });
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "image";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new ImageNode(node.__src, node.__altText, node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(serialized) {
      return $createImageNode(serialized.src, serialized.altText);
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        img: function img() {
          return {
            conversion: convertImageElement,
            priority: 0
          };
        }
      };
    }
  }]);
}(DecoratorNode);

/** Creates an image node. */
export function $createImageNode(src) {
  var altText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return new ImageNode(src, altText);
}

/** Type guard for image nodes. */
export function $isImageNode(node) {
  return node instanceof ImageNode;
}